import { render, staticRenderFns } from "./MainBookCardInv.vue?vue&type=template&id=1b146730"
import script from "./MainBookCardInv.vue?vue&type=script&lang=js"
export * from "./MainBookCardInv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports